<template>
  <div class="con">
    <div class="special-students text-center">
      <h2 class="pb-5">الطلاب الأوائل</h2>
      <div class="content">
        <div class="cards">
          <div class="card" v-for="i in 10" :key="i">
            <div class="number-container">
              <span class="number">{{ i }}</span>
            </div>
            <div class="card-image">
              <img src="../../assets/Ellipse 3.png" alt="" />
            </div>
            <div class="card-body">
              <h3>محمد وليد</h3>
              <p>الصف الأول الثانوي</p>
            </div>
            <div class="card-footer">
              <div class="card-footer-item">
                <span> 4.1 </span>
                <img src="../../assets/Vector.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- <swiper
  :slidesPerView="1"
  :spaceBetween="10"
  :centeredSlides="false"
  :autoplay="false"
  :pagination="false"
  :navigation="false"
  :modules="modules"
  :breakpoints="{
    568: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
    1400: {
      slidesPerView: 5,
      spaceBetween: 10,
    },
  }"
  class="mySwiper cards d-flex justify-content-between align-items-center gap-3"
>
  <swiper-slide
    >
    <div class="card w-100">
      <div class="card-image">
        <img src="../../assets/Ellipse 3.png" alt="" />
      </div>
      <div class="card-body">
        <h3>محمد وليد</h3>
        <p>الصف الأول الثانوي</p>
      </div>
      <div class="card-footer">
        <div class="card-footer-item">
          <span> 4.1 </span>
          <img src="../../assets/Vector.png" alt="" />
        </div>
      </div></div
  >
</swiper-slide>
  <swiper-slide
    ><div class="card w-100">
      <div class="card-image">
        <img src="../../assets/Ellipse 3.png" alt="" />
      </div>
      <div class="card-body">
        <h3>محمد وليد</h3>
        <p>الصف الأول الثانوي</p>
      </div>
      <div class="card-footer">
        <div class="card-footer-item">
          <span> 4.1 </span>
          <img src="../../assets/Vector.png" alt="" />
        </div>
      </div></div
  ></swiper-slide>
  <swiper-slide
    ><div class="card w-100">
      <div class="card-image">
        <img src="../../assets/Ellipse 3.png" alt="" />
      </div>
      <div class="card-body">
        <h3>محمد وليد</h3>
        <p>الصف الأول الثانوي</p>
      </div>
      <div class="card-footer">
        <div class="card-footer-item">
          <span> 4.1 </span>
          <img src="../../assets/Vector.png" alt="" />
        </div>
      </div></div
  ></swiper-slide>
  <swiper-slide
    ><div class="card w-100">
      <div class="card-image">
        <img src="../../assets/Ellipse 3.png" alt="" />
      </div>
      <div class="card-body">
        <h3>محمد وليد</h3>
        <p>الصف الأول الثانوي</p>
      </div>
      <div class="card-footer">
        <div class="card-footer-item">
          <span> 4.1 </span>
          <img src="../../assets/Vector.png" alt="" />
        </div>
      </div></div
  ></swiper-slide>
  <swiper-slide
    ><div class="card w-100">
      <div class="card-image">
        <img src="../../assets/Ellipse 3.png" alt="" />
      </div>
      <div class="card-body">
        <h3>محمد وليد</h3>
        <p>الصف الأول الثانوي</p>
      </div>
      <div class="card-footer">
        <div class="card-footer-item">
          <span> 4.1 </span>
          <img src="../../assets/Vector.png" alt="" />
        </div>
      </div></div
  ></swiper-slide>
</swiper> -->

<script>
// Import Swiper Vue.js components
// import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";

export default {
  name: "SpecialStudentsComponent",
  components: {
    // Swiper,
    // SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>

<style scoped>
.con {
  padding: 4rem 2rem;
}
body.dark .con h2 {
  color: #dad2c5;
}
.con h2 {
  color: #1e1e1e;
  font-size: 2.25rem;
  font-weight: 500;
  margin: 0;
  padding: 0;
}
.swiper {
  /* width: 100%; */
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  /* background: #fff; */

  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.special-students .content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.special-students .cards {
  /* width: 100%; */
  margin: 0 auto;
  overflow: hidden;
  padding: 5rem 0rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 1rem;
  row-gap: 5rem;
}
body.dark .special-students .cards .card {
  background-color: #1e1e1e;
  box-shadow: 0px 3.34px 3.34px 0px #1e1e1e40;
}
.special-students .cards .card {
  background-color: #dad2c5;
  box-shadow: 0px 3.34px 3.34px 0px #ffffff40;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 41px;
  min-width: calc(100% / 4 - 1rem);
  padding: 1.5rem;
  scale: 1;
  transition: all 0.3s ease-in-out;
  border: 0;
  position: relative;
}
.number-container {
  height: 6.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.card:last-of-type .number-container {
  right: -15%;
}
.number {
  font-family: Qatar2022 Arabic;
  font-size: 8rem;
  font-weight: 900;
  text-align: center;
  text-decoration-skip-ink: none;
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke-width: 3px;
  color: #f9a825;
  transition: color 0.3s ease-in-out;
}
body.dark .number {
  color: #f9a82580;
  transition: color 0.3s ease-in-out;
}
.special-students .cards .card:hover {
  scale: 1.025;
}
.special-students .cards .card .card-image {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem;
  position: relative;
  height: 150px;
}
.special-students .cards .card .card-image img {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
}
.special-students .cards .card .card-body {
  border-bottom: 1px solid #00000020;
}
.special-students .cards .card .card-body h3 {
  font-size: 1.5rem;
  color: #0c0c0c;
  font-weight: 500;
  padding: 0;
  margin: 0;
}
.special-students .cards .card .card-body p {
  font-size: 1rem;
  color: #0c0c0c;
  font-weight: 300;
  margin: 0;
  padding: 0;
}
body.dark .special-students .cards .card .card-body h3,
body.dark .special-students .cards .card .card-body p {
  color: #dad2c5;
}
.special-students .cards .card .card-footer {
  border-top: none;
  margin-top: 1rem;
  border-radius: 10px;
  background-color: #2b4239;
  padding: 0.25rem 1rem !important;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.special-students .cards .card .card-footer .card-footer-item {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}
.special-students .cards .card .card-footer .card-footer-item span {
  font-weight: 500;
  font-size: 1.5rem;
  color: #dad2c5;
}
@media (max-width: 1200px) {
  .con {
    padding: 4rem 1rem;
  }
  .special-students .cards .card {
    min-width: calc(100% / 3 - 1rem);
  }
  .number-container {
    height: 5.5rem;
  }
  .number {
    font-size: 7rem;
  }
}
@media (max-width: 768px) {
  .special-students .cards .card {
    min-width: calc(100% / 2 - 1rem);
  }

  .number-container {
    height: 4.5rem;
  }
  .number {
    font-size: 6rem;
  }
}
@media (max-width: 568px) {
  .special-students .cards .card {
    min-width: calc(100% / 1 - 1rem);
  }
}
</style>
